import * as actionTypes from '../config/actionTypes';
import * as formStates from './components/formStates';

const initialState = {
  loading: false,
  error: null,

  count: 0,
  next: null,
  eventList: [],
  newsList: [],
  eventsLoaded: false,
  newsLoaded: false,
  albumsList: [],

  currentEvent: null,
  currentNews: null,
  currentAlbum: null,
  actionLoading: false,
  actionError: null,
  eventJoined: false,
  siteSettings: null,

  eventForm: formStates.eventForm,
};


const toggleLoadingReducer = (state) => {
  return {
    ...state,
    loading: !state.loading,
  };
};


const toggleActionLoading = (state) => {
  return {
    ...state,
    actionLoading: !state.actionLoading,
  };
};


const showErrorReducer = (state, payload) => {
  return {
    ...state,
    error: payload,
  };
};


const unMountReducer = () => {
  return {
    loading: false,
    error: null,
  };
};


const deepUnMountReducer = (state) => {
  return {
    ...initialState,
    eventsLoaded: state.eventsLoaded,
    eventList: state.eventList,
    newsLoaded: state.newsLoaded,
    newsList: state.newsList,
  };
};


const showEventsReducer = (state, payload) => {
  return {
    ...state,
    eventList: [
      ...state.eventList,
      ...payload.results,
    ],
    count: payload.count,
    next: payload.next,
    eventsLoaded: true,
  };
};


const showNewsReducer = (state, payload) => {
  return {
    ...state,
    newsList: [
      ...state.newsList,
      ...payload.results,
    ],
    count: payload.count,
    next: payload.next,
    newsLoaded: true,
  };
};


const showAlbumsReducer = (state, payload) => {
  return {
    ...state,
    albumsList: payload,
  };
};


const showEventItemReducer = (state, payload) => {
  return {
    ...state,
    currentEvent: payload,
  };
};


const showNewsItemReducer = (state, payload) => {
  return {
    ...state,
    currentNews: payload,
  };
};


const showAlbumItemReducer = (state, payload) => {
  return {
    ...state,
    currentAlbum: payload,
  };
};


const showActionErrorReducer = (state, payload) => {
  return {
    ...state,
    actionError: payload,
  };
};


const eventJoinedReducer = (state) => {
  return {
    ...state,
    eventJoined: true,
  };
};


const showSiteSettingsReducer = (state, payload) => {
  return {
    ...state,
    siteSettings: payload,
  };
};


const updateInputsReducer = (state, payload) => {
  return {
    ...state,
    [payload.form]: {
      ...state[payload.form],
      ...payload.data,
    },
  };
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_MAIN_LOADING: return toggleLoadingReducer(state);
    case actionTypes.SHOW_MAIN_ERROR: return showErrorReducer(state, action.payload);
    case actionTypes.UNMOUNT_MAIN: return unMountReducer();
    case actionTypes.DEEP_UNMOUNT_MAIN: return deepUnMountReducer(state);
    case actionTypes.SHOW_EVENTS: return showEventsReducer(state, action.payload);
    case actionTypes.SHOW_NEWS: return showNewsReducer(state, action.payload);
    case actionTypes.SHOW_ALBUMS: return showAlbumsReducer(state, action.payload);
    case actionTypes.SHOW_EVENT_DETAIL: return showEventItemReducer(state, action.payload);
    case actionTypes.SHOW_NEWS_DETAIL: return showNewsItemReducer(state, action.payload);
    case actionTypes.SHOW_ALBUM_DETAIL: return showAlbumItemReducer(state, action.payload);
    case actionTypes.SHOW_MAIN_ACTION_ERROR: return showActionErrorReducer(state, action.payload);
    case actionTypes.EVENT_JOINED: return eventJoinedReducer(state);
    case actionTypes.SHOW_SITE_SETTINGS: return showSiteSettingsReducer(state, action.payload);
    case actionTypes.TOGGLE_MAIN_ACTION_LOADING: return toggleActionLoading(state);
    case actionTypes.UPDATE_MAIN_INPUTS: return updateInputsReducer(state, action.payload);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/main/reducers.js